// Import Firebase core
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Optional (analytics)
import { getAnalytics, isSupported } from "firebase/analytics";

// Your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCrwv_W2x2pG8tDss2SXinwT6UDP439NM4",
  authDomain: "star-aluminium-1ef3d.firebaseapp.com",
  projectId: "star-aluminium-1ef3d",
  storageBucket: "star-aluminium-1ef3d.firebasestorage.app",
  messagingSenderId: "816528100650",
  appId: "1:816528100650:web:bc7b24603e94b4813d2253",
  measurementId: "G-ELLEM87YTM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Firestore DB
export const db = getFirestore(app);

// ✅ Analytics (safe)
let analytics;
isSupported().then((yes) => {
  if (yes) {
    analytics = getAnalytics(app);
  }
});

export { app, analytics };